import { PRODUCT_SORT_KEY as MShopAppKeywordProductSConstantPRODUCT_SORT_KEY } from '../../../../MShop/App/Keyword/Product/S/Constant/product.js';
import { CREW_DOMAIN_NAME as CreatorCrewSCREW_DOMAIN_NAME } from '../../../../Creator/Crew/S/constant.js';

export const NESS_PRODUCT_SORT_KEY = MShopAppKeywordProductSConstantPRODUCT_SORT_KEY;
export const NESS_CREW_DOMAIN_NAME = CreatorCrewSCREW_DOMAIN_NAME;
